import { sliderFontSize } from 'components/template/BumpReport/MainSection';
const { config } = require('./appConfig.ts');

const tenantId = process.env.REACT_APP_TENANT_ID || 'kind';
const appConfig = config[tenantId];

export const errorMessage: string = 'Something went wrong!';

// promo constants
export const NEW_EVENT_PROMO_ID: string = '0';

export const frequencyLabelAltMapping: Record<string, string> = {
    M: 'Months',
    Q: 'Qtrs',
    W: 'Wks',
};

export const frequencyDaysMapping: Record<string, number> = {
    M: 0,
    Q: 0,
    W: 6,
};

export const frequencyFormatMapping: Record<string, string> = {
    M: 'MMM YYYY',
    Q: 'Q YYYY',
    W: appConfig?.commonConfig?.dateFormatAlt,
};

export const priceTrackingFrequencyMapping: Record<string, string> = {
    W: 'weeksOptions',
    M: 'monthsOptions',
    Q: 'quartersOptions',
};

export const sliderMarksConfig: any = {
    W: {
        12: { label: '12W', style: { fontSize: sliderFontSize } },
        32: { label: '26W', style: { fontSize: sliderFontSize } }, //manipulating 32 with 26 because 26 needs to be shown at the center
        52: { label: '52W', style: { fontSize: sliderFontSize } },
    },
    M: {
        3: { label: '3M', style: { fontSize: sliderFontSize } },
        6: { label: '6M', style: { fontSize: sliderFontSize } },
        12: { label: '12M', style: { fontSize: sliderFontSize } },
    },
    Q: {
        1: { label: '1Q', style: { fontSize: sliderFontSize } },
        2: { label: '2Q', style: { fontSize: sliderFontSize } },
        4: { label: '4Q', style: { fontSize: sliderFontSize } },
    },
};
//widget class
export const HIDE_WIDGET_ICON_CLASS = 'hide-widget-icon';

// simulator constants
export const AT_LEAST_ONE_KPI_MUST_BE_SELECTED = 'At least one KPI must be selected';

export const COMPARISON_CHART_CONTAINER_IDS = ['bumpChart-comparison1-main', 'bumpChart-comparison2-main'];
